import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, EventEmitter, Output, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { FeeService } from '@app/services/fees/fee.service';
import { FormBuilder, Validators } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MatCheckbox } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { SnackbarService } from '@app/services/shared/snackbar.service';

interface Payment {
  isFullyPaid: boolean;
  paidDate: string;
  paidAmount: number;
  totalPaidAmount: number;
  totalAmountToPay: number;
  payPercentage: number;
}

interface FeeCalculation {
  feeAfterDiscount: number;
  yearBalance: number;
  discount: number;
}

interface IPrimaryinstitution {
  id: number;
  shortName: string;
}
interface MemberPayments {
  paymentId: number;
  memberId: number;
  givenName: string;
  familyName: string;
  primaryInstitution: String;
  feeAfterDiscount: number;
  fullyPaid: boolean;
  restAmount: number;
  payments: Payment[];
  yearBalance: number;
  paidDate: string,
  paidAmount: number,
  feeCalculation: FeeCalculation,
  rest: number,
  x: boolean
}

interface MemberPaymentsCSV {
  paymentId: number;
  memberId: number;
  givenName: string;
  otherForeNames: string;
  middleName: string;
  familyName: string;
  formerName: string;
  title: string;
  h_CareOf: string;
  h_Street: string;
  h_ZipCode: string;
  h_City: string;
  h_Country: string;
  w_CareOf: string;
  w_Street: string;
  w_ZipCode: string;
  w_City: string;
  w_Country: string;
  o_CareOf: string;
  o_Street: string;
  o_ZipCode: string;
  o_City: string;
  o_Country: string;
  phone: string;
  phone2: string;
  phoneWork: string;
  phoneMobile: string;
  fax: string;
  email1: string;
  email2: String;
  webSite: string;
  initiationDate: string;
  mentor: string;
  mentorId: number;
  birthday: string;
  isSubscriber: boolean;
  localId: number;
  primaryInstitution: String;
  feeAfterDiscount: number;
  fullyPaid: string;
  haveResignLetter: string;
  resignDate: string;
  payments: Payment[];
  yearBalance: number;
  paidDate: string,
  paidAmount: number,
  payPercentage: number,
  feeCalculation: FeeCalculation
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface MemberShort {
  memberId: number;
  givenName: string;
  familyName: string;
}

interface NewPayment {
  memberId: number;
  institutionId: number;
  paidAmount: number;
  paidDate: string;
  action: string;
}

@Component({
  selector: 'app-registerpayments',
  templateUrl: './registerpayments.component.html',
  styleUrls: ['./registerpayments.component.css']
})

export class RegisterpaymentsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() institution: LodgeAndCamp;
  @Input() year: number;
  @Output() doMail = new EventEmitter();
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  @ViewChild('fullypaid') fullypaid;
  @ViewChildren('ElInput') checkboxes!: QueryList<MatCheckbox>;
  loading = false;
  memberpayments: any[] = [];
  memberlist: MemberShort[] = [];
  payments: NewPayment[] = [];
  result = '';
  deleterow = false;
  deleterowid = 0;
  cols: any[];
  subscriptions: Subscription[] = [];
  displayeditdialog = false;
  payment;
  rowdata;
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  filteredValues;
  filteredArray = [];
  selectedmembers: any[] = [];
paymentInProgress: boolean = false;
paymentform;
  
  value: any;
  valuex: any;
  expandedRows: any[] = [];
  expand = true;
  showMailView = false;
  memberslist: any[] = [];
  fullypaidlist: SelectItem[] = [];

  constructor(
    private feeService: FeeService,
    private snackBarService: SnackbarService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe) { }

  ngOnChanges(changes: SimpleChanges) {
    this.paymentform.get('date').setValue(this.year.toString());
    if (changes.year) {
      this.setFullyPaidList();
      this.getPaidFees();
    }
  }

  setFullyPaidList() {
    this.fullypaidlist = [{ label: 'Visa alla', value: '' }, { label: 'Ja', value: true }, { label: 'Nej', value: false }];
  }

  ngOnInit() {
    this.paymentform = this.fb.group({
      date: ['', Validators.required],
      amount: ['', Validators.required],
      year: [null]
    });
    
    this.cols = [
      { field: 'memberId', header: 'Medlemsid' },
      { field: 'givenName', header: 'Förnamn' },
      { field: 'familyName', header: 'Efternamn' },
      { field: 'shortName', header: 'Inst.' },
      { field: 'feeAfterDiscount', header: 'Årsavgift' },
      { field: 'fullyPaid', header: 'Fullbetald' },
      { field: 'yearBalance', header: 'Saldo' },
      { field: 'x', header: 'Kryssa' }
    ];

    this.setFullyPaidList();
      this.getPaidFees();
  }

  getPaidFees() {
    this.loading = true;
    this.subscriptions.push(this.feeService.getPaidFees(this.institution?.id, this.year).subscribe(response => {
      if (response) {
        this.memberpayments = response;
        this.memberpayments.forEach(mp => {
          mp['institutionId'] = mp.primaryInstitution.id;
          mp['shortName'] = mp.primaryInstitution.shortName;
          mp['isActiveMember'] = mp.isActiveMember;
          this.loading = false;
        });
        this.filteredValues = this.memberpayments;
        
        this.memberpayments.forEach(mp => {
          mp['memberId'] = mp.memberId;
          mp['primaryInstitution'] = mp.primaryInstitution;
          mp['fullyPaid'] = mp.feeCalculation.yearBalance >= 0 || (mp.feeCalculation.yearBalance < 1 && mp.feeCalculation.yearBalance > -1) ? true : false;
          mp['yearBalance'] = Math.round(mp.feeCalculation.yearBalance);
          mp['feeAfterDiscount'] = mp.feeCalculation.discount < 1  && mp.feeCalculation.discount > 0.5 ? Math.floor(mp.feeCalculation.feeAfterDiscount) : Math.round(mp.feeCalculation.feeAfterDiscount);
         // mp['feeAfterDiscount'] = mp.feeCalculation.discount <= 0.5 ? Math.round(mp.feeCalculation.feeAfterDiscount) : Math.floor(mp.feeCalculation.feeAfterDiscount);
          console.log('Discount: ' + mp.feeCalculation.feeAfterDiscount + ' - ' + mp.feeCalculation.discount);
        });
       
        if (this.memberpayments) {
          this.generateMemberlist();
        }
        this.loading = false;
        this.paymentInProgress = false;
      }
      this.loading = false;
      this.paymentInProgress = false;
    }));
  }

  onFilter(event, dt) {
    this.filteredValues = event.filteredValue;
  }

  expandCollapse() {
    this.expandedRows = [];
    for (let data of this.memberpayments) {
      this.expandedRows[data.memberId] = this.expand;
    }
    if (!this.expand) {
      this.expandedRows = [];
    }

  }

  getFilteredData() {
    console.log(this.filteredValues);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  edit(row, paymentid) {
    const idx = row?.payments.findIndex(x => {
      return x.paymentId === paymentid;
    });
    this.payment = row?.payments[idx];
    this.payment.paidDate = this.datePipe.transform(this.payment.paidDate, 'yyyy-MM-dd');
    this.rowdata = row;
    this.displayeditdialog = true;
  }

  delete(row, paymentid) {
    console.log(paymentid);
  }

  generateMemberlist() {
    this.memberlist = [];
    this.memberpayments.forEach(payment => {
      const member = {
        memberId: payment.memberId,
        givenName: payment.givenName,
        familyName: payment.familyName
      };
      this.memberlist.push(member);
    });
  }

  savePayment(evt) {
    const payment = {
      paymentId: evt.paymentId,
      memberId: evt.memberId,
      institutionId: this.institution?.id,
      paidAmount: evt.paidAmount,
      paidDate: evt.paidDate,
      action: 'update'
    };
    this.payments.push(payment);
    this.subscriptions.push(this.feeService.addPaidFee(this.payments).subscribe(resp => {
      if (resp) {
        this.payments = [];
        this.paymentform.reset();
        this.getPaidFees();
        this.snackBarService.openSnackBar('Betalningen har uppdaterats.', null);
      }
    }));
    this.displayeditdialog = false;
  }

  cancelEdit() {
    this.displayeditdialog = false;
  }

  setMemberId(evt: any) {
  }

  registerPayments() {
    const re = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
    if (this.paymentform.get('date').value.match(re)) {
      if (this.selectedmembers?.length > 0) {
        this.paymentInProgress = true;
        this.payments = [];
        this.selectedmembers.forEach(m => {
          const payment = {
            memberId: m,
            institutionId: this.institution?.id,
            paidAmount: this.paymentform.get('amount').value,
            paidDate: this.paymentform.get('date').value,
            yearPaid: this.year,
            action: 'add'
          };
          this.payments.push(payment as any);
        });
        this.subscriptions.push(this.feeService.addPaidFee(this.payments).subscribe(resp => {
          this.payments = [];
          this.selectedmembers = [];
          this.paymentform.reset();
          this.paymentform.patchValue({ year: this.year });
          this.getPaidFees();
          this.snackBarService.openSnackBar('Betalningen har sparats.', null);
        }));
      } else {
        this.snackBarService.openSnackBar('Välj en eller flera medlemmar.', null);
      }
    } else {
      this.snackBarService.openSnackBar('Kontrollera datumformatet.', null);
    }
  }

  deletePayment(rowdata, p: any) {
    this.payments = [];
    const payment = {
      paymentId: p.paymentId,
      memberId: rowdata.memberId,
      institutionId: rowdata.feeCalculation.institutionId,
      paidAmount: p.paidAmount,
      paidDate: p.paidDate,
      action: 'delete'
    };
    this.payments.push(payment);
    this.subscriptions.push(this.feeService.addPaidFee(this.payments).subscribe(resp => {
      if (resp) {
        if (rowdata.payments?.length < 2) {
          this.expandedRows[rowdata.memberId] = false;
        }
        this.getPaidFees();
        this.snackBarService.openSnackBar('Betalningen är raderad.', null);
      }
    }));
  }

  confirm(rowdata, p: any) {
    this.confirmDialog(rowdata, p);
  }

  confirmDialog(rowdata, p: any): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald betalning?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         this.deletePayment(rowdata, p);
      },
      reject: () => {
      }
    });
  }

  exportToExtendedCSV() {
    this.filteredArray = [];
    this.feeService.GetPaidFeesCSV(this.institution.id, this.year).subscribe(resp => {
      resp.forEach(x => {
        const idx = this.filteredValues.findIndex(fv => fv.memberId === x.memberId);
        if (idx !== -1) {
          x.primaryInstitution = this.filteredValues[idx].primaryInstitution;
          x.feeAfterDiscount = this.filteredValues[idx].feeAfterDiscount;
          x.fullyPaid = this.filteredValues[idx].fullyPaid;
          x.totalBalance = this.filteredValues[idx].totalBalance;
          x.yearBalance = this.filteredValues[idx].yearBalance;
          this.filteredArray.push(x);
        }
      });
      this.generateCSV();
    });
  }

  generateCSV() {
    let data = [];
    this.filteredArray.forEach(async m => {
      let row: MemberPaymentsCSV;
      const memberinfo = m.memberInfo;
      row = {
        memberId: memberinfo.id,
        givenName: memberinfo.givenName,
        otherForeNames: memberinfo.otherForeNames,
        middleName: memberinfo.middleName,
        familyName: memberinfo.familyName,
        formerName: memberinfo.formerName,
        title: memberinfo.title,
        h_CareOf: memberinfo.h_CareOf,
        h_Street: memberinfo.h_Street,
        h_ZipCode: memberinfo.h_ZipCode,
        h_City: memberinfo.h_City,
        h_Country: memberinfo.h_Country,
        w_CareOf: memberinfo.w_CareOf,
        w_Street: memberinfo.w_Street,
        w_ZipCode: memberinfo.w_ZipCode,
        w_City: memberinfo.w_City,
        w_Country: memberinfo.w_Country,
        o_CareOf: memberinfo.o_CareOf,
        o_Street: memberinfo.o_Street,
        o_ZipCode: memberinfo.o_ZipCode,
        o_City: memberinfo.o_City,
        o_Country: memberinfo.o_Country,
        phone: memberinfo.phone ? memberinfo.phone + String.fromCharCode(8203) : '',
        phone2: memberinfo.phone2 ? memberinfo.phone2 + String.fromCharCode(8203) : '',
        phoneWork: memberinfo.phoneWork ? memberinfo.phoneWork + String.fromCharCode(8203) : '',
        phoneMobile: memberinfo.phoneMobile ? memberinfo.phoneMobile + String.fromCharCode(8203) : '',
        fax: memberinfo.fax ? memberinfo.fax + String.fromCharCode(8203) : '',
        email1: memberinfo.email1,
        email2: memberinfo.email2,
        webSite: memberinfo.webSite,
        initiationDate: this.datePipe.transform(memberinfo.initiationDate, 'yyyy-MM-dd'),
        mentor: memberinfo.mentor ? memberinfo.mentor.givenName + ' ' + memberinfo.mentor.familyName : '',
        mentorId: memberinfo.mentor?.mentorId,
        birthday: memberinfo.birthday,
        isSubscriber: memberinfo.isSubscriber,
        localId: memberinfo.localId,
        primaryInstitution: m.primaryInstitution?.shortName + ' - ' + m.primaryInstitution?.name,
        paidDate: m.paidDate,
        paidAmount: m.paidAmount,
        yearBalance: m.yearBalance,
        feeAfterDiscount: m.feeAfterDiscount,
        payPercentage: m.payPercentage,
        fullyPaid: m.fullyPaid ? 'Ja' : 'Nej',
        haveResignLetter: memberinfo.haveResignLetter ? 'Ja' : '',
        resignDate: this.datePipe.transform(memberinfo.resignDate, 'yyyy-MM-dd'),
        feeCalculation: m.feeCalculation,
        payments: m.payments,
        paymentId: m.paymentId
      };

      if (m.payments.length === 0) {
        data.push(row);
      } else {
        await this.getPaymentRowsExtended(data, m.payments, m);
      }
      let idx = 0;
    });
    const firstrow = 'Medlemsnummer;Förnamn;Övriga Förnamn;Mellannamn;Efternamn;Tidigare efternamn;Yrke/Titel;Bostad C/O;Bostad Gata/Box;Bostad Postnummer;Bostad Ort;Bostad Land;Arbete C/O;Arbete Gata/Box;Arbete Postnummer;Arbete Ort;Arbete Land;Annan C/O;Annan Gata/Box;Annan Ort;Annan Postnummer;Annan Land;Telefon 1;Telefon 2;Arbetstelefon;Mobiltelefon;Fax;E-post 1;E-post 2;Hemsida;Invigd datum;Fadder;Medlemsnummer Fadder;Födelsedatum;SOFT;Lokalt medlemsnummer;Primärinstitution;Betaldatum;Belopp - Inbetalt belopp;Saldo - Ackumulerat beloppet som är inbetalt detta år;Årsavgift - Förväntad årsinbetalning;Betalar % - Ev registrerad nedskrivningsprocent;Fullbetald - (J/N);Avgångsgbrev;Utträdesdatum'
    const datum = this.datePipe.transform(new Date(), 'yyMMdd');
    const filnamn = 'Medlemsavgifter-' + this.year + '_' + datum;
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  exportToCSV() {
    let data = [];
    if (!this.filteredValues) {
      this.filteredValues = this.memberpayments;
    }
    this.filteredValues.forEach(async m => {
      let row: MemberPayments;
      row = {
        memberId: m.memberId,
        givenName: m.givenName,
        familyName: m.familyName,
        primaryInstitution: m.primaryInstitution?.shortName + ' - ' + m.primaryInstitution?.name,
        feeAfterDiscount: m.feeAfterDiscount,
        fullyPaid: m.fullyPaid,
        restAmount: m.restAmount,
        paymentId: null,
        paidDate: '',
        payments: [],
        yearBalance: m.yearBalance,
        feeCalculation: null,
        paidAmount: null,
        rest: null,
        x: null
      };
      if (m.payments.length === 0) {
        data.push(row);
      } else {
        await this.getPaymentRows(row, data, m.payments, m);
      }
      data.push(row);
      let idx = 0;
    });
    const firstrow = 'Medlemsid;Förnamn;Efternamn;Primärinstitution;Årsavgift;Fullbetald;Saldo;Datum;Belopp';
    const filnamn = 'OF_Medlemsavgifter';
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  getPaymentRowsExtended(data, payments, m) {
    let idx = 0;
    let row1;
    payments.forEach(p => {
      const memberinfo = m.memberInfo;
      row1 = {
        memberId: memberinfo.id,
        givenName: memberinfo.givenName,
        otherForeNames: memberinfo.otherForeNames,
        middleName: memberinfo.middleName,
        familyName: memberinfo.familyName,
        formerName: memberinfo.formerName,
        title: memberinfo.title,
        h_CareOf: memberinfo.h_CareOf,
        h_Street: memberinfo.h_Street,
        h_ZipCode: memberinfo.h_ZipCode,
        h_City: memberinfo.h_City,
        h_Country: memberinfo.h_Country,
        w_CareOf: memberinfo.w_CareOf,
        w_Street: memberinfo.w_Street,
        w_ZipCode: memberinfo.w_ZipCode,
        w_City: memberinfo.w_City,
        w_Country: memberinfo.w_Country,
        o_CareOf: memberinfo.o_CareOf,
        o_Street: memberinfo.o_Street,
        o_ZipCode: memberinfo.o_ZipCode,
        o_City: memberinfo.o_City,
        o_Country: memberinfo.o_Country,
        phone: memberinfo.phone,
        phone2: memberinfo.phone2,
        phoneWork: memberinfo.phoneWork,
        phoneMobile: memberinfo.phoneMobile,
        fax: memberinfo.fax,
        email1: memberinfo.email1,
        email2: memberinfo.email2,
        webSite: memberinfo.webSite,
        initiationDate: this.datePipe.transform(memberinfo.initiationDate, 'yyyy-MM-dd'),
        mentor: memberinfo.mentor ? memberinfo.mentor?.givenName + ' ' + memberinfo.mentor?.familyName : '',
        mentorId: memberinfo.mentor ? memberinfo.mentorId : '',
        birthday: memberinfo.birthday,
        isSubscriber: memberinfo.isSubscriber,
        localId: memberinfo.localId,
        primaryInstitution: m.primaryInstitution?.shortName + ' - ' + m.primaryInstitution?.name,
        paidDate: p.paidDate,
        paidAmount: p.paidAmount,
        yearBalance: m.yearBalance,
        feeAfterDiscount: m.feeAfterDiscount,
        payPercentage: p.payPercentage,
        fullyPaid: m.fullyPaid ? 'Ja' : 'Nej',
        haveResignLetter: memberinfo.haveResignLetter ? 'Ja' : '',
        resignDate: this.datePipe.transform(memberinfo.resignDate, 'yyyy-MM-dd')
      }
      row1.paidDate = this.datePipe.transform(p.paidDate, 'yyyy-MM-dd');
      row1.paidAmount = p.paidAmount;
      data.push(row1);
      idx++;
    });
  }

  getPaymentRows(row, data, payments, m) {
    let idx = 0;
    let row1;
    payments.forEach(p => {
      row1 = {
        memberId: m.memberId,
        givenName: m.givenName,
        familyName: m.familyName,
        primaryInstitution: m.primaryInstitution?.shortName + ' - ' + m.primaryInstitution?.name,
        feeAfterDiscount: m.feeAfterDiscount,
        fullyPaid: m.fullyPaid,
        yearBalance: m.yearBalance,
        paidDate: p.paidDate,
        paidAmount: p.paidAmount,
        rest: null
      }
      row1.paidDate = this.datePipe.transform(p.paidDate, 'yyyy-MM-dd');
      row1.paidAmount = p.paidAmount;
      data.push(row1);
      idx++;
    });
  }

  add(data, element) {
    if (element.checked) {
      this.selectedmembers.push(data.memberId);
      data.x = true;
      const member = {
        id: data.memberId,
        givenName: data.givenName,
        familyName: data.familyName,
        email1: data.email
      };
      this.memberslist.push(member);
    } else {
      this.removeFromArray(data.memberId);
      data.x = false;
      this.removeMemberFromArray(data.memberId);
    }
  }

  selectAllFilteredRows() {
      let idx = 0;
      this.checkboxes.forEach((checkbox) => {
        checkbox.checked = !checkbox.checked;
        this.add(this.filteredValues[idx], checkbox);
        idx++;
      });
  }

  removeFromArray(id: number) {
    const idx = this.selectedmembers.findIndex(memberid => memberid === id);
    this.selectedmembers.splice(idx, 1);
  }

  removeMemberFromArray(id) {
    const idx = this.memberslist.findIndex(m => m === id);
    this.memberslist.splice(idx, 1);
  }

  closeEmail(evt) {
    this.memberslist = [];
    this.selectedmembers = [];
    this.showMailView = false;
    this.doMail.emit(false);
  }

  sendMail() {
    this.showMailView = true;
    this.doMail.emit(true);
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const mp of this.memberpayments) {
      mp.x = value;
      this.add(mp, element);
    }
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
    this.fullypaid.selectedOption = { label: 'Visa allt', value: '' };
    this.filteredValues = this.memberpayments;
  }

}
